//====================================================
//  Function: Reviews
//====================================================
function componentReviews() {
  if ($("#reviews").length) {
    $("#reviews").load("hodnoceni-obchodu .votes-wrap", function (
      response,
      status,
      xhr
    ) {
      if ($(".votes-wrap").length) {
        $(".vote-wrap").wrap('<div class="swiper-slide"></div>');
        $(".votes-wrap").addClass("swiper-wrapper");
        $(".votes-wrap").wrap(
          '<div class="swiper-container js-slider-reviews"></div>'
        );
        $(".swiper-container").wrap(
          '<div class="js-slider-group slider-group-reviews"></div>'
        );

        var arrowTemplate =
          '<div class="swiper-arrow swiper-arrow-next js-swiper-arrow-next">' +
          '<div class="swiper-arrow-content">' +
          '<svg class="icon-svg icon-chevron-right">' +
          '<use xlink:href="https://www.lahvinka.eu/user/documents/public/images/sprites.svg#icon-chevron-right"></use>' +
          " </svg > " +
          " </div>" +
          " </div>" +
          '<div class="swiper-arrow swiper-arrow-prev js-swiper-arrow-prev">' +
          '<div class="swiper-arrow-content">' +
          '<svg class="icon-svg icon-chevron-left">' +
          '<use xlink:href="https://www.lahvinka.eu/user/documents/public/images/sprites.svg#icon-chevron-left"></use>' +
          " </svg > " +
          " </div>" +
          " </div>";
        $(".js-slider-group").append(arrowTemplate);

        reviewsSlider();
      }
    });
  }
}
